function handleTabIndex(cmp) {
    if (cmp.disabled) {
        // cache current tabindex
        cmp._tabIndex = cmp.elm.tabIndex;
        // force to -1 for disabled elements
        cmp.elm.tabIndex = -1;
    }
    else {
        // reset to cached local state
        cmp.elm.tabIndex = cmp._tabIndex;
        // Prop takes precedence
        if (typeof cmp.tabIndex !== 'undefined') {
            cmp.elm.tabIndex = cmp.tabIndex;
        }
    }
}

export { handleTabIndex as h };
